/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const BtnIconEyeOff1 = ({ className, color = "black" }) => {
  return (
    <svg
      className={`btn-icon-eye-off-1 ${className}`}
      fill="none"
      height="25"
      viewBox="0 0 25 25"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="g" clipPath="url(#clip0_2627_1332)">
        <path
          className="path"
          d="M14.62 14.9633C14.3454 15.258 14.0141 15.4944 13.6462 15.6584C13.2782 15.8224 12.8809 15.9105 12.4781 15.9176C12.0753 15.9247 11.6752 15.8506 11.3016 15.6998C10.9281 15.5489 10.5887 15.3243 10.3038 15.0394C10.019 14.7545 9.79439 14.4152 9.64351 14.0417C9.49262 13.6681 9.41853 13.268 9.42563 12.8652C9.43274 12.4624 9.52091 12.0651 9.68488 11.6971C9.84884 11.3291 10.0853 10.9979 10.38 10.7233M1.5 1.84326L23.5 23.8433M18.44 18.7833C16.7306 20.0863 14.6491 20.8081 12.5 20.8433C5.5 20.8433 1.5 12.8433 1.5 12.8433C2.74389 10.5252 4.46914 8.49987 6.56 6.90326L18.44 18.7833ZM10.4 5.08326C11.0883 4.92214 11.7931 4.8416 12.5 4.84326C19.5 4.84326 23.5 12.8433 23.5 12.8433C22.893 13.9789 22.1691 15.048 21.34 16.0333L10.4 5.08326Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>

      <defs className="defs">
        <clipPath className="clip-path" id="clip0_2627_1332">
          <rect
            className="rect"
            fill="white"
            height="24"
            transform="translate(0.5 0.843262)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
